import { BaseService } from "@flint/framework";

export default class EPubSyncData extends BaseService {
  constructor() {
    super("SYNC_EPUB_DATA", "EPubSyncResStore", true);
  }

  handleEvent(eventName, ePubISBN) {
    // console.log("handleSync");
    // console.log(ePubISBN);
    return this.getClient("vetService").post(`/admin-api/epubs/cloud-search/`, null,{
      params: {
        "isbn": ePubISBN,
      },
    });
  }
}